export default __webpack_public_path__ + "static/media/Series-9700-MPNH-Inline-FAT.4ee7a863.png";